import Axios from "axios";

const API_URL = "https://cms.vidhaantextiles.com/api/user-action-logs";

// Resolves the api itemType + the payload key the product id must be sent
// against: stocks -> { itemType: "stock", key: "stock" },
// knits -> { itemType: "knit", key: "knit" }, everything else (woven) ->
// { itemType: "fabric", key: "fabric" }.
export const resolveItemType = (itemType) => {
  const category = itemType?.toString().toLowerCase();

  if (category === "stock" || category === "stocks") {
    return { itemType: "stock", key: "stock" };
  }
  if (category === "knit" || category === "knits") {
    return { itemType: "knit", key: "knit" };
  }
  if (category === "woven" || category === "fabric" || category === "fabrics") {
    return { itemType: "fabric", key: "fabric" };
  }

  // Category not passed (or unknown) - fall back to the current view.
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "";
  const storedCategory = localStorage.getItem("category")?.toLowerCase();
  const isKnitsMode = localStorage.getItem("isKnitsMode") === "true";

  if (pathname.includes("/stocks") || storedCategory === "stocks") {
    return { itemType: "stock", key: "stock" };
  }
  if (pathname.includes("/knits") || storedCategory === "knits" || isKnitsMode) {
    return { itemType: "knit", key: "knit" };
  }
  return { itemType: "fabric", key: "fabric" };
};

export const logUserAction = async (action, fabricId, itemType) => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const { itemType: finalItemType, key } = resolveItemType(itemType);

  console.log("logUserAction", {
    action,
    id: fabricId,
    itemType: finalItemType,
    key,
    userId,
  });

  if (!token || !userId) return;

  try {
    await Axios.post(
      API_URL,
      {
        data: {
          user: parseInt(userId),
          itemType: finalItemType,
          [key]: fabricId,
          action: action,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    console.error("Error logging user action:", error);
  }
};
